// Theme colors for DruidVision Dashboard
export const colors = {
    // Colori primari del tema
    primary: {
        dark: '#05291d',   // Verde scuro
        light: '#87bf59',  // Verde chiaro
    },

    // Verde (tema principale)
    greenDark: '#05291d',       // Verde scuro principale
    greenLight: '#87bf59',      // Verde chiaro principale
    greenMedium: '#38A169',     // Verde medio (Chakra UI green.500)
    greenMediumDark: '#2F855A', // Verde medio scuro (Chakra UI green.600)

    // Grigi
    gray50: '#f7fafc',          // Grigio chiaro (sfondo)
    gray100: '#f1f1f1',         // Grigio molto chiaro
    gray200: '#e4e7ec',         // rgb(228, 231, 236) convertito
    gray300: '#cbd5e0',         // Grigio chiaro medio
    gray400: '#a0aec0',         // Grigio medio

    // Bianco
    white: '#ffffff',

    // Background colors
    pageBg: '#f9fafb',          // rgb(249, 250, 251) convertito

    // Shadows (rgba)
    shadow: {
        light: 'rgba(0, 0, 0, 0.05)',
        medium: 'rgba(0, 0, 0, 0.1)',
        whiteOverlay: 'rgba(255, 255, 255, 0.1)',
    },
};

// Export default per import semplice
export default colors;
